// src/components/Products.jsx
import React, { useState } from "react";
import { productsData } from "./productsData";
import ProductCard from "./ProductCard";
import ProductModal from "./ProductModal";
import "./products.css";

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  const openModal = (product, size) => {
    setSelectedProduct(product);
    setSelectedSize(size);
  };

  const closeModal = () => {
    setSelectedProduct(null);
    setSelectedSize(null);
  };

  const cleaners = productsData.filter((p) => p.category === "cleaner");
  const fresheners = productsData.filter((p) => p.category === "airfresh");

  return (
    <div id="products" className="product-container">

      <h2 className="section-title">Eco Organic & Laboratory Professional Cleaners</h2>
      <div className="card-grid">
        {cleaners.map((product) => (
          <ProductCard key={product.id} product={product} onOpen={openModal} />
        ))}
      </div>

      <h2 className="section-title">Premium Air Fresheners Collection</h2>
      <div className="card-grid-Af">
        {fresheners.map((product) => (
          <ProductCard key={product.id} product={product} onOpen={openModal} />
        ))}
      </div>

      <ProductModal
        selected={selectedProduct}
        selectedSize={selectedSize}
        onClose={closeModal}
      />
    </div>
  );
};

export default Products;
